import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AuthPages.css';

export default function ClientLogin() {
  const navigate = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    if (localStorage.getItem('clientToken')) navigate('/client/portal');
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch('/api/client-portal/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'Login failed.');
      localStorage.setItem('clientToken', data.token);
      localStorage.setItem('clientDealId', data.dealId);
      navigate('/client/portal');
    } catch { setError('Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">BrokerConnect</div>
        <h1 className="auth-title">Client Portal Login</h1>
        <p className="auth-subtitle">Log in to upload your documents securely.</p>
        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>Email Address</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com" className="auth-input" required />
          </div>
          <div className="auth-field">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="auth-input" required />
          </div>
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Logging in…' : 'Log In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', fontSize: 13, color: '#718096', marginTop: 20 }}>
          First time? Use the link from your invitation email.
        </p>
      </div>
    </div>
  );
}
